'use client';

import Header from '@/components/common/Header';
import { useCart } from '@/contexts/CartContext';
import ClientOnly from '@/components/common/ClientOnly';

export default function HeaderWrapper() {
  const { cartCount } = useCart();

  return (
    <ClientOnly>
      <Header cartItemCount={cartCount} isAuthenticated={false} />
    </ClientOnly>
  );
}
